import { useAppSelector } from '@verantos-dev/app-state-base';
import { selectCohortProfileIsLoading } from '@verantos-dev/app-state-cohort-definition';

/**
 * This hook is used to determine whether the cohort builder should be in a loading state or not.
 */
export const useCohortBuilderSkeleton = () => {
  const isCohortProfileLoading = useAppSelector(selectCohortProfileIsLoading);

  return {
    isCohortProfileLoading,
  };
};
